function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5073 17.5474H3.21313V18.9444H15.5073V17.5474Z",
  fill: "#249AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5723 6.30127H7.26471C6.87888 6.30127 6.56616 6.61399 6.56616 6.99982C6.56616 7.38565 6.87888 7.69837 7.26471 7.69837H11.5723C11.9581 7.69837 12.2708 7.38565 12.2708 6.99982C12.2708 6.61399 11.9581 6.30127 11.5723 6.30127Z",
  fill: "#249AF3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8321 9.56152H7.26471C6.87888 9.56152 6.56616 9.87424 6.56616 10.2601C6.56616 10.6459 6.87888 10.9586 7.26471 10.9586H14.8321C15.218 10.9586 15.5306 10.6459 15.5306 10.2601C15.5306 9.87424 15.2179 9.56152 14.8321 9.56152Z",
  fill: "#249AF3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5884 0.146597C18.3376 0.0338955 18.0445 0.0783897 17.8386 0.260226L15.8825 1.99071L13.9241 0.239482C13.6588 0.00220397 13.2579 0.00220397 12.9927 0.239482L11.0368 1.9886L9.08068 0.239482C8.81546 0.00220397 8.41475 0.00220397 8.14953 0.239482L6.19108 1.99071L4.23497 0.260226C4.02938 0.0786123 3.73599 0.0341181 3.48521 0.146597C3.23468 0.259521 3.07355 0.508674 3.07355 0.783432V13.2173H0.698548C0.312721 13.2173 0 13.53 0 13.9158V15.6156C0 17.4515 1.49369 18.9452 3.32965 18.9452V17.5481C2.26394 17.5481 1.39706 16.681 1.39706 15.6156V14.6143H12.3407V15.6156C12.3407 17.4515 13.8344 18.9452 15.6704 18.9452C17.5063 18.9452 19 17.4516 19 15.6156V0.783395C19 0.508637 18.8389 0.259521 18.5884 0.146597ZM17.603 15.6156C17.603 16.681 16.7359 17.5481 15.6704 17.5481C14.6049 17.5481 13.7378 16.681 13.7378 15.6156V13.9158C13.7378 13.53 13.4251 13.2173 13.0393 13.2173H4.47061V2.3339L5.731 3.449C5.99644 3.68372 6.39552 3.68253 6.65933 3.44644L8.61522 1.69733L10.5711 3.44622C10.8363 3.6835 11.2373 3.6835 11.5025 3.44622L13.4586 1.6971L15.4145 3.44622C15.6785 3.68231 16.0776 3.68324 16.3428 3.44878L17.603 2.33394V15.6156Z",
  fill: "#249AF3"
});

function SvgRefiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefiIcon);
export default __webpack_public_path__ + "static/media/REFIIcon.84e0aeb1.svg";
export { ForwardRef as ReactComponent };